import IAppInfo from "models/IAppInfo";
import { IAppState } from "state";

export const info = (state: IAppInfo | null = null) => state;

export const getState = (state: IAppState) => state.info;
